export default function closeWindow() {
  window.postMessage({
    type: 'CLOSE_WINDOW',
    meta: { source: 'scheduler' },
  }, window.location.origin);
}
